// Common chrome around every widget. The header is always present so
// per-widget controls (filters, timeframe chips) stay reachable without
// entering edit mode. Drag + close are edit-mode only:
//  - Drag handle = the header bar only fires drag when the cockpit is in
//    edit mode AND the click lands outside the headerExtras slot.
//  - Close (×) only renders for non-pinned widgets in edit mode.
//
// `headerExtras` is the slot widgets use to inject their own chips
// (e.g. 1h/24h, sort, filter). Clicks on extras stop propagation so they
// don't start a drag.

import React from 'react';

function WidgetFrame({ title, editing, onHide, pinned, headerExtras, children }) {
  return (
    <div className={`cockpit-widget ${editing ? 'editing' : ''} ${pinned ? 'pinned' : ''}`}>
      <div className={`cockpit-widget-header ${editing ? 'cockpit-drag-handle' : ''}`}>
        <span className="cockpit-widget-title">{title}</span>
        {headerExtras && (
          <div
            className="cockpit-widget-extras"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            {headerExtras}
          </div>
        )}
        {editing && !pinned && (
          <button
            type="button"
            className="cockpit-widget-close"
            onClick={(e) => { e.stopPropagation(); onHide?.(); }}
            onMouseDown={(e) => e.stopPropagation()}
            title="Hide widget"
            aria-label={`Hide ${title}`}
          >
            ×
          </button>
        )}
      </div>
      <div className="cockpit-widget-body">{children}</div>
    </div>
  );
}

export default React.memo(WidgetFrame);
